var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7593 3.24V3.52H11.0793V5.16H8.6393C8.49263 6.05333 8.21263 6.76667 7.7993 7.3C7.3993 7.82 6.82596 8.2 6.0793 8.44C5.33263 8.66667 4.36596 8.78 3.1793 8.78V10.04C3.1793 10.7733 3.33263 11.3533 3.6393 11.78C3.9593 12.2067 4.49263 12.42 5.2393 12.42C6.5993 12.42 7.2793 11.6533 7.2793 10.12H9.3793C9.36596 11.4667 8.9993 12.4867 8.2793 13.18C7.57263 13.86 6.54596 14.2 5.1993 14.2C3.85263 14.2 2.8193 13.8267 2.0993 13.08C1.39263 12.3333 1.0393 11.2867 1.0393 9.94V7.2C2.5193 7.2 3.60596 7.16 4.2993 7.08C4.99263 6.98667 5.50596 6.8 5.8393 6.52C6.18596 6.24 6.41263 5.78667 6.5193 5.16H0.199297V3.52H6.6193V3.24V1.74H0.199297V0.0799992H11.0793V1.74H8.7593V3.24Z",
    fill: "#5F1CCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/₹.2f05bbead629b0b0feb3f0d162d7330c.svg";
export { ForwardRef as ReactComponent };